import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import Storage from 'src/utils/storage/storage';
import { ENDPOINTS } from '../../constants';
import Logo from './Logo';

const SiteLogoAndNameContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  overflowX: 'hidden',
  // width: `30px`,
  backgroundColor: theme.palette.primary.background
}));

const LogoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflowX: 'hidden',
  height: `40px`,
  maxHeight: `40px`,
  // padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
  width: `calc(${theme.spacing(7)} + 3px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`
  },
  [theme.breakpoints.up('md')]: {
    width: `calc(${theme.spacing(7)} + 3px)`
  }
  // padding: theme.spacing(0, 1),
}));

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.sideMenuTitleColor};
  font-weight: bold;
`;

const StyledRouterLink = styled(RouterLink)`
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 14px;
  font-color: ${({ theme }) => theme.palette.primary.contrastText};
  font-weight: 500;
`;

export default function StyledSiteLogoAndName(props) {
  // const { isAuthenticated } = useAuth()
  const isAuthenticated =
    typeof Storage.getToken() === 'string' && Storage.getToken();
  // console.log(props, "these are props inside drawer")
  const { isDark, size, needLogo, needName, width, height } = props;
  return (
    <StyledRouterLink
      to={isAuthenticated ? ENDPOINTS.homeUrl : ENDPOINTS.loginUrl}
    >
      <SiteLogoAndNameContainer>
        {needLogo ? (
          <LogoBox>
            <Logo
              component={'logo'}
              theme={isDark ? 'Dark' : 'Light'}
              size={size == 'full' ? 'FULL' : 'SMALL'}
              width={width ? width : '100%'}
              height={height ? height : '100%'}
            />
          </LogoBox>
        ) : null}
        {needName ? (
          <StyledTypography variant='h4' align='center' noWrap>
            {localStorage.getItem('site_title')}
          </StyledTypography>
        ) : null}
      </SiteLogoAndNameContainer>
    </StyledRouterLink>
  );
}
